<script>
    import {catalogStore} from "../../common/store/catalog-store";

    export default {
        name: "CatalogFetch",

        methods: {
            sort(value) {
                let url = new URL(window.location.href);

                // Reseta página
                url.searchParams.delete('page');

                if (value) url.searchParams.set('sort', value);
                else url.searchParams.delete('sort');

                return url.toString();
            },

            url(param, id, link, remove, currentUrl = null) {
                let url = new URL(currentUrl || window.location.href);

                // Remove parâmetro de paginação para voltar para a primeira página
                url.searchParams.delete('page');

                // Remove ou adiciona parâmetro informado
                if (remove) {
                    url.searchParams.delete(param);
                } else if (!this.selected.pretty_url || (this.selected.pretty_url && (param === 'preco' || param === 'tamanho' || param === 'inPhysicalStock' || param === 'multipleFabrics'))) {
                    // Utiliza URL amiga passada como parâmetro se for
                    url.searchParams.set(param, param === 'tamanho' ? link : id);
                }

                let joinPath = function (path, val, i, array) {
                    if (path === undefined) return val;
                    if (val === undefined) return path;

                    if (remove && (
                        param === 'tipo' && i === 0 ||
                        param === 'categoria' && i === 1 ||
                        param === 'genero' && i === 2 ||
                        param === 'cor' && i === 3))
                        return path;

                    return path + '/' + val;
                };

                url.pathname = this.selected.pretty_url
                    ? [
                    param === 'tipo' ? (remove ? this.selected.type_main_url : link) : this.selected.type_url,
                    param === 'categoria' ? link : this.selected.category_url,
                    param === 'genero' ? link : this.selected.gender_url,
                    param === 'cor' ? link : this.selected.color_url,
                ].reduce(joinPath) + '/'
                    : url.pathname;

                return url.toString();
            },

            fetch(scroll, event, url, pushEvent = true) {
                if (pushEvent) {
                    window.dataLayer.push({
                        event: 'clickOnCatalogFilter'
                    });
                }

                // Carregamento dinâmico se a API pushState estiver disponível
                if (typeof (history.pushState) !== 'function') return true;

                event.preventDefault();

                url = new URL(url ? url : event.currentTarget.href);

                catalogStore.fetchState(
                    this.axios,
                    location.origin + url.pathname + url.search,
                    url.pathname + url.search
                );
            },
        }
    }
</script>